import { Flex, FlexProps } from 'rebass';
import FilePreview from './FilePreview';
import React from 'react';
import { S3File } from './types';
import { UtilityIconButton } from '../Button/UtilityIconButton';

type File = Pick<S3File, 'thumb' | 'url'> & { contentType: string | null };

type FilePreviewsProps<F extends File> = FlexProps & {
  files: F[];
  onDelete?: (file: F) => void;
};

function FilePreviews<F extends File = File>({
  files,
  onDelete,
  ...props
}: FilePreviewsProps<F>) {
  if (!files || !files.length) {
    return <></>;
  }
  return (
    <Flex
      {...(props as any)}
      flexDirection="row"
      flexWrap="wrap"
      sx={{
        gap: 2,
        m: '3px',
        mb: '1px',
        alignItems: 'flex-start',
        alignContent: 'flex-start',
      }}
    >
      {files.map((file) => (
        <Flex
          sx={{
            alignContent: 'center',
            position: 'relative',
            justifyContent: 'space-between',
            maxWidth: 'calc(50% - 8px)',
            width: '100%',
            height: 125,
            flexGrow: 0,
            display: 'inline-flex',
            '.delete-button': {
              display: 'none',
            },
            ':hover': {
              '.delete-button': {
                display: 'flex',
              },
            },
          }}
          href={file.url}
          target="_blank"
          key={file.url}
        >
          {onDelete && (
            <UtilityIconButton
              className="delete-button"
              dark
              sx={{
                position: 'absolute',
                top: 2,
                right: 2,
                boxShadow: 'm',
              }}
              icon="trash"
              onClick={() => onDelete?.(file)}
            />
          )}
          <FilePreview file={file} />
        </Flex>
      ))}
    </Flex>
  );
}

export default FilePreviews;
